<template>
  <section class="page-container">
    <h1>{{quoteType == 'renew'? 'Switch Insurer': 'Quote Saved'}}</h1>
    <div class="border-box">
      <p>{{quoteType == 'renew'? "This quote’s insurer has been switched.": "This quote has been saved to the customer's account"}}</p>
      <v-button
        @click="routerToPolicy"
      >View Quote</v-button>

    </div>
    <div class="border-box">
      <p class="bold-content">Send Payment and Signature Link</p>
      <v-button
        type="success"
        @click="handlerDialog(1)"
      >Using SMS</v-button>
      <v-button
        @click="handlerDialog(3)"
      >Email</v-button>
    </div>
    <div class="border-box">
      <p class="bold-content">Pay on behalf and Send Signature Link</p>

      <v-button
        @click="handlerPay"
      >
        <span class="icon"><font-awesome-icon
          icon="money-bill-wave"></font-awesome-icon></span>
        <span>Pay on behalf</span></v-button>
    </div>
    <set-manual-dialog
      ref="manual-dialog"
      :form="detailData"
      :orderId="orderId"
      :is-sme="smeClassId>80"
      is-show-code
      @saveManual="saveManual"
    >
    </set-manual-dialog>
    <contact-dialog
      ref="contact-dialog"
      :type="contactType"
      :ticketId="detailData.ticketId"
      :initPhone="detailData.phone"
      :initEmail="detailData.send_email"
      :customerData="customerData"
      :initCustomerId="detailData.customer_id"
      :share-link="detailData.url_data"
    />

    <send-email-sms
      ref="send-email-sms"
      :form="detailData"
      :type="contactType == 1? 1: 2"
      :initContent="detailData.url_data"
      @send="handlerSend"
      @skip="handlerSkip" />

  </section>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import setManualDialog from '@/views/components/set-manual-dialog'
import {createGeneralTicket, getTicketRelationList, setTicketRelation} from '@/api/ticket'
import ContactDialog from '@/views/tickets/dialogs/contact-dialog'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

import {
  getQuoteDetail,
  paymentLinkSend
} from '@/api/quote'
import {getSMEQuoteDetail} from '@api/sme'

export default {
  name: 'PaymentSuccess',
  components:{
    setManualDialog,
    ContactDialog,
    SendEmailSms
  },
  mixins: [MixinOptions, MixinRules],
  data() {
    return {
      contactType:0,
      type:[],
      typeOptions: [
        {
          name: 'General',
          id: 1
        },
        {
          name: 'Refer Case',
          id: 2
        }
      ],
      search: '',
      ticketForm: {
        subject: '',
        assignee_id: '',
        // customer_id: '',
        message: ''
      },
      ticketList: [],
      detailData: {
        customer: {}
      },
      selectIndex: -1,
      // customerId: ''
    }
  },
  computed: {
    ...mapState('common', ['productId','customerOptionsUser']),

    orderId() {
      return this.$route.query.order_id
    },
    customerId() {
      return this.detailData.customer_id
    },
    pcyId() {
      return this.$route.query.pcy_id
    },
    quoteNo() {
      return this.$route.query.quote_no
    },
    smeClassId() {
      return this.$route.query.class_id
    },
    quoteType() {
      return this.$route.query.type || ''
    },

    customerData(){
      return{
        contact_phone:this.detailData.phone,
        contact_email:this.detailData.send_email
      }
    },
    isPaidSignature(){
      const {stts,is_signature} = this.detailData
      return stts>=401&&(is_signature==1||is_signature==0)||stts==0
    },
    customer_name(){
      return  this.detailData.customer.isrd_nm
    },
    customerName() {
      const {
        cust_typ,
        isrd_lst_nm,
        isrd_fst_nm,
        contact_nm } = this.detailData
      if(cust_typ == 1) {
        return `${isrd_lst_nm} ${isrd_fst_nm}`
      }

      return contact_nm
    },
    customerPhone() {
      const { cust_typ, mobile_no, contact_phone } = this.detailData
      if(cust_typ == 1) {
        return mobile_no
      }
      return contact_phone
    }
  },
  watch: {
    // property: {
    //   immediate: true,
    //   handler() {
    //     if(this.productId == 12){
    //
    //     }
    //     this.network().getCarQuoteDetail()
    //     this.network().getTicketRelationList()
    //   }
    // }
    smeClassId:{
      //   immediate: true,
      //   handler() {
      //     if(this.productId == 12){
      //
      //     }
      //     this.network().getCarQuoteDetail()
      //     this.network().getTicketRelationList()
      //   }
    }
  },
  created() {
    // this.customerId = this.$route.query.customer_id
    if(this.smeClassId){
      this.network().getSMEQuoteDetail()
      return
    }
    this.network().getQuoteDetail()
    // switch(Number(this.productId)) {
    //   case 12:
    //     this.network().getHousemaidQuoteDetail()
    //     break
    //   case 11:
    //     this.network().getCarQuoteDetail()
    //     break
    //   case 13:
    //     this.network().getWorkingQuoteDetail()
    //     break
    //   case 14:
    //     this.network().getTravelQuoteDetail()
    //     break
    //   case 15:
    //     this.network().getInteriorQuoteDetail()
    //     break
    //   case 16:
    //     this.network().getStudentQuoteDetail()
    //     break
    //   case 17:
    //     this.network().getHomefireQuoteDetail()
    //     break
    //   case 18:
    //     this.network().getPersonalQuoteDetail()
    //     break
    //   case 20:
    //     this.network().getHomefireQuoteDetail()
    //     break
    // }
    // this.network().getTicketRelationList()
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),
    ...mapActions('quote', ['setIsBack']),
    handlerDialog(type){
      this.contactType = type
      this.$refs['manual-dialog'].changeDialog()
    },
    saveManual(isSend){
      this.refreshPolicy()
      // this.$refs['contact-dialog'].changeDialog()
      if(isSend)
        this.$refs['send-email-sms'].changeDialog()
    },
    refreshPolicy(){
      if(this.smeClassId){
        this.network().getSMEQuoteDetail()
        return
      }
      this.network().getQuoteDetail()
    },
    handlerSend(content) {
      this.network().paymentLinkSend({
        content,
        is_send: 1
      })
    },
    handlerSkip() {
      this.network().paymentLinkSend({
        content: '',
        is_send: 0
      })
    },
    handlerPay(){
      if(this.isPaidSignature) {
        this.$router.push({
          path: '/records/quote/detail',
          query: {
            order_id: this.orderId,
            product_id: this.productId,
          }
        })
      }
      else{
        this.$router.push({
          path: '/quoting/payment',
          // path: '/quoting/payment/success',
          query: {
            order_id: this.orderId,
            product_id: this.productId,
            quote_type: this.quoteType == 'renew'? 'renew': ''
          }
        })
      }
    },
    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    routerToPolicy() {
      this.setIsBack(false)
      this.$router.push({
        path:'/records/quote/detail',
        query: {
          order_id: this.orderId,
          product_id:this.productId,
        }
      })
    },
    clientClick() {

    },
    rowClick(row) {
      // this.selectIndex = row.index
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    filterData() {
      this.network().getTicketRelationList()
    },
    handlerAttach() {
      this.network().setTicketRelation()
    },
    createTicket(status) {
      this.$refs.form.validate(valid => {
        if(valid) {
          if(status) {
            this.network().createGeneralTicket({
              status: 3
            })
          } else {
            this.network().createGeneralTicket()
          }
          this.setCustomerOptionNUll()
        }
      })
    },
    network() {
      return {
        getSMEQuoteDetail:async ()=>{
          let {data} = await getSMEQuoteDetail({
            order_id:this.orderId
          },this.productId)
          this.detailData = data
        },
        getQuoteDetail: async () => {
          let { data } = await getQuoteDetail({
            order_id: this.orderId
          },this.productId)
          this.formData = data
          this.detailData = data
        },
        getTicketRelationList: async () => {
          const { data } = await getTicketRelationList({
            customer_id: this.customerId,
            search: this.search,
            type:this.type
          })
          // this.selectIndex = -1
          // data.map((item, index) => {
          //   item.index = index
          //   return item
          // })
          this.ticketList = data
        },
        setTicketRelation: async () => {
          const { data } = await setTicketRelation({
            id: this.ticketList[this.selectIndex].id,
            quote_no: this.quoteNo
          })
          this.$message({
            type: 'success',
            message: data.message_language? data.message_language: data.message
          })
        },
        createGeneralTicket: async (params = {}) => {
          const { data } = await createGeneralTicket({
            ...this.ticketForm,
            quote_no: this.quoteNo,
            customer_id: this.customerId,
            ...params
          })
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        },
        paymentLinkSend: async (params = {}) => {
          const { data } = await paymentLinkSend({
            ...params,
            order_id: this.orderId,
            send_type: this.contactType == 1? 1: 2,
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })

        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
    h1 {
        padding-bottom: 5px;
    }
      .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #d5d8de;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
    .flex {
        margin-top: 15px;
        .card {
            margin-right: 15px;
            width: 448px;
        }
      h3 {
        padding-bottom: 10px;
        font-size: 20px;
      }
      .left {
        padding: 15px 10px 15px 15px;
        border-right: 1px solid #dddfe7;

        .mg-t-10 {
          margin-top: 10px;
        }
        .mg-b-10 {
          margin-bottom: 10px;
        }
        .client {
          font-size: 16px;
          font-weight: 500;
          & > span {
            display: inline-block;
            padding-left: 5px;
            font-weight: 400;
          }
        }
      }
      .right {
        padding: 15px 15px 15px 10px;
      }
    }
  .border-box{
    p{
      padding:32px 0 16px 0;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
    }
    padding-bottom: 32px;
    border-bottom: 1px solid #E1E4E8;
    //margin-bottom: 31px;

  }
  .bold-content{
    font-weight: bold;
    padding:32px 0 16px 0;
    color: #24292E;
    font-family: Inter;
    font-size: 14px;
    letter-spacing: 0;
  }
  .icon{
    margin-right: 10px;
  }
}
</style>

